import React, { useState } from "react"; // Added useState
import { Box, Grid, Typography, TextField, List, ListItem, ListItemIcon, ListItemText,CircularProgress } from "@mui/material"; // Added List, ListItem, ListItemIcon, ListItemText
import CustomButton from "../components/CustomButton";
import ContactHeader from "./ContactHeader";
import CustomText, { textStyles } from "../components/CustomText"; // Imported textStyles
import { useTranslation } from "react-i18next";
import FAQsSection from "./HomeScreen/FAQsSection";
// import yes from "../../assets/yes.svg"; // Imported yes
import { useTheme } from "@mui/material/styles"; // Imported useTheme
import { useMediaQuery } from "@mui/material"; // Imported useMediaQuery
import ParallaxItem from "../components/ParallexSection"
import {BASE_URL} from '../components/BASE_URL';
import {toast,Toaster} from "react-hot-toast"
const ContactPage = () => {
  const { t } = useTranslation();
  const theme = useTheme(); // Added theme
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")); // Added isMobile
const [isLoading, setIsLoading] = useState(false);

  // State for form fields
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  // Placeholder values - you can replace these with actual content for the contact page
  const imagePosition = "left"; // Or "right"
  const isImageLeft = imagePosition === "left";
  const image = "https://st3.depositphotos.com/1000975/37750/i/450/depositphotos_377503434-stock-photo-call-center-operator-working-at.jpg"; // Example image path
  const title = t("contactUs.title") || "Contact Us"; // Example title
  // const description = t("contactUs.description") || "We'd love to hear from you. Here's how you can reach us."; // Example description - REMOVED
  // const features = [ // REMOVED
  //   t("contactUs.feature1") || "24/7 Support",
  //   t("contactUs.feature2") || "Quick Response Time",
  //   t("contactUs.feature3") || "Multiple Contact Channels",
  // ]; // Example features - REMOVED
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!name || !email || !subject || !message) {
    toast.error(t("contact.fillFields"));
    return;
  }

  setIsLoading(true);

  try {
    const response = await fetch(`${BASE_URL}/contact-us`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        email,
        subject,
        message,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      toast.error(t("contact.failed"));
      throw new Error();
    }

    toast.success(t("contact.success"));

    // Clear fields
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");

  } catch (err) {
    toast.error(t("contact.error"));
  } finally {
    setIsLoading(false);
  }
};



  return (
    <Box
      sx={{

      }}
    >
      <Toaster/>
      <ContactHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: isImageLeft ? "row" : "row-reverse" },
          alignItems: "center",
          gap: 6,
        }}
      >

        {!isMobile && (
          <Box sx={{
            flex: 1,
            marginTop: "70px",
            textAlign: "center",
            // backgroundColor: "red",
          }}>
            <Box
              sx={{
                width: {
                  sx: "100%",
                  sm: "100%",
                  md: "50%",
                },
                // maxWidth: "100px",
                height: "100%",
                // align innerbox to right
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                margin: "0 auto",

              }}
            >
              <Box
                component="img"
                src={image}
                alt={title}
                sx={{
                  width: "100%",
                  // maxWidth: "100px",
                  height: "100%",
                  borderRadius: "30px",

                }}
              />
            </Box>
          </Box>
        )}
        {/* Text Section */}
        <Box sx={{
          flex: 1,

          width: "100%",
        }}>
          <Box
            component="form" // Changed to form
             onSubmit={handleSubmit}
            sx={{
              mt: 4,
              backgroundColor: "#fff",
              borderRadius: 3,
              px: { xs: 2, md: 3 }, // Added padding
              py: { xs: 3, md: 4 }, // Added padding
              width: { xs: "100%", sm: "100%", md: "50%" }, // Responsive width
              border: "1px solid #DFDFDF",
              display: "flex", // Added for layout
              flexDirection: "column", // Added for layout
              gap: 2, // Added for spacing between fields
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              label={t("Name")}
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
              inputProps={{ sx: { fontSize: '0.875rem' } }}
            />
            <TextField
              label={t("Email")}
              variant="outlined"
              fullWidth
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
              inputProps={{ sx: { fontSize: '0.875rem' } }}
            />
            <TextField
              label={t("Subject")}
              variant="outlined"
              fullWidth
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
              inputProps={{ sx: { fontSize: '0.875rem' } }}
            />
            <TextField
              label={t("Message")}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
              inputProps={{ sx: { fontSize: '0.875rem' } }}
            />
           <CustomButton
  type="submit"
  buttonVariant="primary"
  sx={{ mt: 2 }}
  disabled={isLoading} // disable button while loading
  label={
    isLoading ? (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CircularProgress size={18} sx={{ color: "#fff" }} />
        {t("Sending...")}
      </Box>
    ) : (
      t("Send Message")
    )
  }
/>



          </Box>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: "white", pb: { xs: 2, md: 4 } }}>

                           <FAQsSection />
                       </Box>
    </Box>
  );
};

export default ContactPage;
